import { NotificationsSidebarItem } from '@backstage/plugin-notifications';

/**
 * Sidebar notifications entry.
 *
 * Intentionally does not call useSignal here: NotificationsSidebarItem already
 * subscribes to the notifications channel. A parent useSignal raced
 * SignalClient.connect() and opened a duplicate WebSocket.
 */
export const CustomNotificationsSidebarItem = () => (
  <NotificationsSidebarItem titleCounterEnabled />
);
